import {
	FETCH_USERS_SUCCESS,
	FETCH_USERS_BEGIN, GET_FILTERED_USER
} from '../actions/usersActions';

const defaultUsersState =  {
	users: [],
	pagination: {},
	loading: false,
	error: null
};

export const users = (state = defaultUsersState, action) => {
	switch (action.type) {
		case FETCH_USERS_BEGIN:
			return {
				...state,
				loading: true,
				error: null
			};

		case FETCH_USERS_SUCCESS:
			return {
				...state,
				loading: false,
				users: action.payload.users,
				pagination: {
					numberOfElements : action.payload.numberOfElements,
					totalElements: action.payload.totalElements,
					totalPages: action.payload.totalPages
				},
			};
		default:
			return state;
	}
};


export const filteredUsersList = (state = defaultUsersState, action) => {
	switch (action.type) {
	case GET_FILTERED_USER:
		return {
			...state,
			users: action.users
		};
	default:
		return state;
	}
};



// WEBPACK FOOTER //
// ./src/reducers/users.js